// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1-E7V","loaderOuter":"PageOverlayLoader_loaderOuter___Stvk"};